import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SwitchBox } from '../../../molecules/switch-box';

export const SettingsHpSpotFlexibility = () => {
  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="heat_pump.flexi_sp.flexi_reduce_on"
            defaultMessage="Odložení spotřeby "
          />
        }
        switchVariableId="SP_HP_NOW_REDUCE_ON"
        visibility={{ variableId: 'SP_INSTALL' }}
        subtitle={
          <FormattedMessage
            id="heat_pump.flexi_sp.flexi_reduce_on.subtitle"
            defaultMessage="Režim umožní odložení spotřeby při vysoké ceně energie"
          />
        }
        fullWidth
      />
      <SwitchBox
        title={
          <FormattedMessage
            id="heat_pump.flexi_sp.flexi_increase_on"
            defaultMessage="Zvýšení spotřeby "
          />
        }
        switchVariableId="SP_HP_NOW_INCREASE_ON"
        visibility={{ variableId: 'SP_INSTALL' }}
        subtitle={
          <FormattedMessage
            id="heat_pump.flexi_sp.flexi_increase_on.subtitle"
            defaultMessage="Režim umožní zvýšení spotřeby při nízké ceně energie"
          />
        }
        fullWidth
      />
    </>
  );
};
